import axios from 'axios';
import { EnvironmentConfig } from '../constants.js';

export default {
    name: 'CommonService',
    data() {
        return {
            baseApiUrl: '',
            APIKey: ''
        }
    },
    created: function () {
        //URL and endpoint constants
        this.baseApiUrl = EnvironmentConfig._baseURL;
        this.APIKey = EnvironmentConfig._APIURL;
    },
    methods: {
        GetMasterDetails() {
            const bankClientDetails = this.baseApiUrl + '/api/TaxTransformation/GetMasterDetails';
            const params = ["acr.banks", "acr.clients"];
            return axios({
                method: 'post',
                url: bankClientDetails,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response)
                    return response
            }).catch(error => {
                return error;
            })
        },
        ClientMapping(appname) {
            const clientMapUrl = this.baseApiUrl + '/api/TaxTransformation/AppClients';
            const params = {
                'UserName': localStorage.getItem('userName'),
                'AppName': appname,
                'FirstName': localStorage.getItem('firstName'),
                'LastName': localStorage.getItem('lastName'),
            }
            return axios({
                method: 'post',
                url: clientMapUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response) {
                    return response;
                }
            })
                .catch(function () {
                });
        },
        ImportUploadedFile(formdata) {
            const uploadFileUrl = this.baseApiUrl + '/api/TaxTransformation/ApplicationDetails';
            return axios.post(uploadFileUrl,
                formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                }
            }
            ).then(function (response) {
                if (response) {
                    return response;
                }
            });
        },
        SaveDetails(saveJsonArray) {
            const saveFileUrl = this.baseApiUrl + '/api/TaxTransformation/Save';
            return axios({
                method: 'post',
                url: saveFileUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: saveJsonArray
            })
                .then(function (responseSave) {
                    if (responseSave) {
                        return responseSave;
                    }
                })
                .catch((error) => {
                    return error;
                });
        },
        DownloadFile(fileName) {
            axios({
                url: this.baseApiUrl + '/api/TaxTransformation/DownloadFiles?fileName=' + fileName,
                method: 'GET',
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            })
                .catch(function () {
                });
        },
        GetFileHeaders() {
            const headersUrl = this.baseApiUrl + '/api/TaxTransformation/GetColumnHeaders';
            return axios({
                method: 'post',
                url: headersUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: {
                    'AppId': localStorage.getItem('appId'),
                    'UserDetails': {
                        'FirstName': localStorage.getItem('firstName'),
                        'LastName': localStorage.getItem('lastName'),
                        'AppName': localStorage.getItem('appKey'),
                        'UserName': localStorage.getItem('userName'),
                    }
                }
            })
                .then(function (responseFetch) {
                    if (responseFetch) {
                        return responseFetch;
                    }
                })
                .catch((error) => {
                    return error;
                });
        },
        SaveFileHeaders(selectedItems) {
            const saveHeadersUrl = this.baseApiUrl + '/api/TaxTransformation/SaveColumnHeaders';
            return axios({
                method: 'post',
                url: saveHeadersUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: {
                    'FileType': selectedItems.fileType,
                    'MappingId': selectedItems.mappingId,
                    'ExcelColumnName': selectedItems.excelColumnName,
                    'DbColumnName': selectedItems.dbColumnName,
                    'ColumnHeaderId': selectedItems.columnHeaderId,
                    'AppId': selectedItems.appId,
                    'UserDetails': {
                        'UserId': selectedItems.userDetails.userId,
                        'FirstName': selectedItems.userDetails.firstName,
                        'LastName': selectedItems.userDetails.lastName,
                        'AppName': selectedItems.userDetails.appName,
                        'UserName': localStorage.getItem('userName')
                    }
                }
            })
                .then(function (responseSave) {
                    if (responseSave) {
                        return responseSave;
                    }
                })
                .catch((error) => {
                    return error;
                });
        },
        DeleteFileHeader(selectedItems) {
            const deleteUrl = this.baseApiUrl + '/api/TaxTransformation/DeleteColumnHeaders';
            return axios({
                method: 'post',
                url: deleteUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: {
                    'AppId': selectedItems.appId,
                    'ColumnHeaderId': selectedItems.columnHeaderId,
                    'UserDetails':
                    {
                        'UserId': selectedItems.userDetails.userId,
                        'FirstName': selectedItems.userDetails.firstName,
                        'LastName': selectedItems.userDetails.lastName,
                        'AppName': selectedItems.userDetails.appName,
                        'UserName': localStorage.getItem('userName')
                    }
                }
            })
                .then(function (responseDelete) {
                    if (responseDelete) {
                        return responseDelete;
                    }
                })
                .catch((error) => {
                    return error;
                });
        },
        GetFileTypes() {
            const headersUrl = this.baseApiUrl + '/api/TaxTransformation/GetDefaultColumns';
            return axios({
                method: 'post',
                url: headersUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: {
                    'AppId': localStorage.getItem('appId'),
                    'UserDetails':
                    {
                        'UserId': localStorage.getItem('userId'),
                        'FirstName': localStorage.getItem('firstName'),
                        'LastName': localStorage.getItem('lastName'),
                        'AppName': localStorage.getItem('appKey'),
                        'UserName': localStorage.getItem('userName')
                    }

                }
            })
                .then(function (response) {
                    if (response) {
                        return response;
                    }
                })
                .catch((error) => {
                    return error;
                });

        },
        UserApplicationPermission(inviteJson) {
            const userapppermissionUrl = this.baseApiUrl + '/users/SaveUserApplicationPermissions';
            return axios({
                method: 'post',
                url: userapppermissionUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: inviteJson
            })
                .then(function (response) {
                    if (response) {
                        return response;
                    }
                });
        },
        GetUserDetails() {
            const userDetails = this.baseApiUrl + '/users/GetUserApplicationPermissionDetails';
            const params = {
                'FirstName': localStorage.getItem('firstName'),
                'LastName': localStorage.getItem('lastName'),
                'UserName': localStorage.getItem('userName')
            };
            return axios({
                method: 'post',
                url: userDetails,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response)
                    return response
            }).catch(error => {
                return error;
            })
        },
        GetClientDetails() {
            const headersUrl = this.baseApiUrl + '/api/TaxTransformation/GetCITClients';
            return axios({
                method: 'post',
                url: headersUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: {
                    'UserName': localStorage.getItem('userName')
                }
            }).then(function (responseFetch) {
                if (responseFetch) {
                    return responseFetch;
                }
            }).catch((error) => {
                return error;
            });
        },
        SaveCitClient(clientDetails) {
            const apiUrl = this.baseApiUrl + '/api/TaxTransformation/SaveCITClients';
            return axios({
                method: 'post',
                url: apiUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: clientDetails
            }).then(function (responseSave) {
                if (responseSave) {
                    return responseSave;
                }
            }).catch((error) => {
                return error;
            })
        },
        ImportZipFolder(formdata) {
            const uploadFileUrl = this.baseApiUrl + '/api/TaxTransformation/ZipUpload';
            return axios.post(uploadFileUrl,
                formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                }
            }
            ).then(function (response) {
                if (response) {
                    return response;
                }
            });
        },

        getTransactionsReport(transType, fromDate, tillDate) {
            var transactionsAPI = "";
            var body = {
                "FromDt": fromDate,
                "TillDt": tillDate,
                "UserID": parseInt(localStorage.getItem("userId"))
            }

            if(transType == "ACRReport")
                transactionsAPI = this.baseApiUrl + '/admin/ACRTransactions'; 
            else if(transType == "CITReport")
                transactionsAPI = this.baseApiUrl + '/admin/CITTransactions';

            return axios({
                method: 'post',
                url: transactionsAPI,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: body
            }).then(function (result) {
                    return result;
            }).catch((error) => {
                return error;
            })
        }
    }
}





